import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-batch-del-purch-lines-bs',
  templateUrl: './batch-del-purch-lines-bs.component.html',
  styleUrls: ['./batch-del-purch-lines-bs.component.css']
})
export class BatchDelPurchLinesBsComponent implements OnInit {
    batchDelPurchLineKeyno;

    batchDeliveryKeyno;

    public selectedBgBatchPurchaseLinesBs: string = '0';

    public setting?: Setting;

    public inputListPurchaseLines: PurchaseLineItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.batchDelPurchLineKeyno = this.stateService.getStateParams()['batchdelpurchline_keyno'];
        this.batchDeliveryKeyno = this.stateService.getStateParams()['batchdelivery_keyno'];
    }

    private async loadSetting() {
        if (!!this.batchDeliveryKeyno) {
            this.setting = (await this.datatask.Post(299, { batchdelivery_keyno: this.batchDeliveryKeyno }))[0];
        }
    }

    private async loadPurchaseLines() {
        if (!!this.batchDelPurchLineKeyno && !!this.batchDeliveryKeyno) {
            this.inputListPurchaseLines = await this.datatask.Post(288, {
                batchdelpurchline_keyno: this.batchDelPurchLineKeyno,
                batchdelivery_keyno: this.batchDeliveryKeyno
            });
        }
    }

    public async saveChanges() {
        if (!!this.inputListPurchaseLines) {
            try {
                this.saving = true;

                await this.datatask.Post(291, { records: this.inputListPurchaseLines });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadSetting();
        this.loadPurchaseLines();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    show_save_button: string;
}

interface PurchaseLineItem {
    batchdelpurchlinesb_keyno: string;
    batchdelpurchline_keyno: string;
    quantity: string;
    stockbatch_keyno: string;
    price_locval: string;
    amount_locval: string;
    amount_invval: string;
    purchprice_locval: string;
    purchprice_invval: string;
    country_id_origin: string;
    valuta_id: string;
    suppliers_batchno: string;
    best_before_date: string;
    orderby: string;
    freight_EU: string;
    freight_ex_EU: string;
    customs_eu: string;
    customs_ex_eu: string;
    divcost: string;
    item_id: string;
    item_name: string;
    item_state: string;
    item_parms: string;
    item_path: string;
}
